const teamData = [
    {
        "id": 1,
        "name": "강다현",
        "number": "2171317",
        "track": "웹공학트랙", 
        "role": "기획 및 CalcResult, Location 페이지 개발",
        "git": "https://github.com/hyeonda02",
        "image": "images/2171317.png"
    },
    {
        "id": 2,
        "name": "박시현",
        "number": "2171335",
        "track": "모바일소프트웨어트랙", 
        "role": "기획 및 Pills 페이지 개발",
        "git": "https://github.com/boxion",
        "image": "images/2171335.png"
    },
        {
        "id": 3,
        "name": "양인서",
        "number": "2171339",
        "track": "모바일소프트웨어트랙", 
        "role": "디자인 및 Login & Sign up, Home, Team 페이지 개발",
        "git": "https://github.com/sheepyis",
        "image": "images/2171339.png"
    },
        {
        "id": 4,
        "name": "오유진",
        "number": "2171431",
        "track": "모바일소프트웨어트랙", 
        "role": "디자인 및 Calc, Loading 페이지 개발",
        "git": "https://github.com/0hyujin",
        "image": "images/2171431.png"
    }
]

export default teamData;